import { makeStyles } from "@material-ui/core/styles";

export default makeStyles(theme => ({
  root: {
    display: "flex",
    justifyContent: "center"
  },
  paper: {
    padding: theme.spacing(2),
    margin: theme.spacing(3)
  },
  formHeight: {
    height: 500
  },
  formControl: {
    margin: theme.spacing(3),
    display: "flex"
  },
  opcionCarrier: {
    height: 100
  },
  formCol: {
    // display: "flex",
    // justifyContent: "spaceBetween",
    // height: "100%"
    flexGrow: 1
  },
  formItem: {
    width: "100%",
    marginBottom: theme.spacing(2),
    // marginRight: theme.spacing(1),
    flexGrow: 1
  },
  titulo: {
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2),

    flexGrow: 1
  },
  select: {
    // zIndex: "2!important",
    width: "100%",
    justifyContent: "center"
    // marginRight: theme.spacing(1)
  },
  botonAgregar: {
    padding: theme.spacing(1)
  },
  botonCotizar: {
    margin: theme.spacing(2),
    padding: theme.spacing(2),
    float: "left"
  },
  botonEliminar: {
    padding: theme.spacing(2),
    float: "left"
  },
  botonGenerar: {
    margin: theme.spacing(2),
    padding: theme.spacing(2),
    float: "right"
  },
  spinner: {}
}));
